import { BaseEntity } from '../../../core';

export class DriverExpData extends BaseEntity {

    sex: string;
    civilState: string;
    documentType: string;
    state: string;

    isActive: boolean;
    documentNumber: string;
    name: string;
    lastName: string;
    address: string;
    city: string;
    postalCode: string;
    phone: string;
    cellPhone: string;
    nationality: string;
    bornDate: Date = null;
    licenseType: string;
    licenseNumber: string;
    licenseCnrt: string;
    licenseExpiration: Date = null;
    file: string;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/exports/driverExpData.ts